export enum ItemStatus {
  NotYetCreated = -1,
  Idea = 1,
  cebApproved = 3,
  cebComplete = 5,
  Removed = 6,
  Concept_Review = 10,
  Not_Pursued = 11,
  Review_Done_Start_Production = 12,
  PendingForApproval = 2,
  Approved = 3,
  Rejected = 4,
  Complete = 5,
  PublishedHistoricalNonCPP = 8,
  PendingCPPItemCreation = 12,
  PendingRetirement = 20,
  Retired = 25,
  Outline = 100,
  OutlineReview = 200,
  KILeaderApproval = 201,
  TMApproval = 202,
  Draft = 300,
  DraftPeerReview = 310,
  MandatoryReview = 400,
  PreEditingIntake = 410,
  PreEditingEditorReview = 420,
  PreEditingAnalystReview = 430,
  TeamManagerSignoff = 500,
  ExternalReview = 600,
  PreFlightReview = 680,
  WaitingforEditing = 690,
  Production = 700,
  Published = 800,
  PendingRepublish = 900,
  PostProductionExternalReview = 710,
  EditorIntake = 706,
  ReadyforAssignment = 707,
  EditorReview = 708,
  AuthorReview = 709,
  FinalEditingrReview = 711,
  PublishPreparation = 712,
  InitialEditingIntake = 701,
  PrepForTranslation = 750,
  TranslationFinalEdit = 756,
  ProofreadingIntake = 730,
  Proofreading = 740,
  TextPrepIntake = 702,
  TextPrep = 703,
  FinalEditorReview = 720,
  RetractedTemporary = 9,
  FinalTeamManagerReview = 650,
  Concept = 50,
  ConceptReviewCPP = 60,
  ConceptReviewOnHold = 70,
  LightUpdateDraft = 3000,
  LightUpdateFinalSignoff = 3100,
  LightUpdatePreFlightTeamReview = 3150,
  WaitingforLUEditing = 3175,
  LightUpdateEditingIntake = 3200,
  LightUpdateEditorReview = 3300,
  LightUpdateProofreading = 3350,
  LightUpdatePrepPublication = 3400,
  DevEditingIntake = 4000
}

export enum CreativeStatus {
  CreativeIntake = 1000,
  CreativeIntakeOnHold = 1005,
  CreativeInProgress = 1100,
  CreativeComplete = 1200,
  CreativeBypassed = 7,
  CreativeScoping = 1010,
  CreativeNeedMoreInfo = 1020,
  CreativeReadyforAssignment = 1030,
  CreativeAdditionalCreativeDesign = 1130,
  CreativeAuthorReview = 1150,
  CreativeAdditionalCreativeDesignReview = 1170,
  PromoteToCreative = 990,
  WaitingForDesign = 995
}
